import { useAuthState } from '../useAuthState'
import { useAvailablePlansSWR } from '@app/common/src/hooks/useAvailablePlansSWR'
import { useEffect, useState } from 'react'

/**
 * Billing admins are users that can buy and change plans for themselves
 * or their org.
 *
 * Logged out users are not billing admins, but they may become one once
 * they log into an account that is.
 */
export function useIsBillingAdmin(): boolean | undefined {
  const [isBillingAdmin, setIsBillingAdmin] = useState<boolean | undefined>(undefined)

  // Per Cabe, we do not have a dedicated way from the API to denote a billing admin
  // but checking if they have any available plans is an equivalent way to know.
  // - BASIC users will
  // - PRO, PRO PLUS, and GROWTH will if they own the org, members will not
  //   - NOTE: GROWTH doesn't have a higher plan, but current plan will be available
  // - ENTERPRISE users will not, and they cannot change plans via app so that works
  // - logged out users also will not, and they must log in in order to change plans
  const authState = useAuthState()
  const availablePlansSWR = useAvailablePlansSWR(
    () => {
      if (!authState.token) return
      return {
        token: authState.token
      }
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnMount: true
    }
  )

  useEffect(() => {
    if (!authState.isAuthChecked) return

    if (!authState.isAuthenticated) {
      setIsBillingAdmin(false)
    } else if (availablePlansSWR.data) {
      setIsBillingAdmin(availablePlansSWR.data.length > 0)
    }
  }, [authState.isAuthChecked, authState.isAuthenticated, availablePlansSWR.data])

  return isBillingAdmin
}
